/**
 * Stops the mouse wheel from rewriting a focused number field.
 *
 * Chrome and Edge step an `<input type="number">` by one on every wheel tick while it has focus and
 * the pointer is over it. On a long form that is exactly what happens on the way to the Save button:
 * type 90 into "Max grace days", scroll down, and the field quietly reads 74 by the time it is saved
 * — a different number on every attempt, with nothing on screen saying the scroll did it. A grace
 * cap saved that way then cancels paying customers weeks early.
 *
 * Installed once on the document rather than per field, so every number input in the console —
 * flowbite's `Input` forwards no wheel event — and every one added later is covered. The field is
 * blurred instead of the event being cancelled: the wheel then scrolls the page, which is what the
 * person was doing.
 */
export function installNumberInputWheelGuard(root: Document): () => void {
	const onWheel = (event: Event): void => {
		const target = event.target;
		if (target instanceof HTMLInputElement && target.type === 'number' && root.activeElement === target) {
			target.blur();
		}
	};
	root.addEventListener('wheel', onWheel, { capture: true, passive: true });
	return () => root.removeEventListener('wheel', onWheel, { capture: true });
}
